export const EnvironmentBaseUrls: Record<string, string> = {
  local: 'http://localhost:3101',
  development: 'https://vectry-backend-svc-dev.azurewebsites.net',
  production: 'https://api.vectry.io'
};
